module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_307888696_L-small-5dfdc728352b26127db526bbe1df1536.jpg";